module.exports = __webpack_public_path__ + "img/header.d135720e.jpg";